<template>
	<div id="sdk">
		<div class="header">
				  <div class="logo-box">
					  <img class="logo" src="https://cdn.huimiaokeji.com/hjweb/logo.png"/>
				  </div>
				  <div class="top-menu">
					灰鲸SDK下载
				  </div>
				  <div class="login-box" @click="goUrl('https://admin.huimiaokeji.com')">
					  <div class="login-btn">
						  登录
					  </div>
				  </div>
		</div>
		<div class="platform-section" id="platform-section">
					<div class="content-box-wrap">
					<div class="content-box" style="margin-top: 150px;">
						<div class="content-item">
							<div class="item-title">Android</div>
							<div class="item-description">版本号：2.6.1</div>
							<div class="item-btns">
								<div class="btn" @click="goUrl('https://www.showdoc.com.cn/2474466204336934/10988523076585890')">接入文档</div>
								<div class="btn" @click="goUrl('https://cdn.huimiaokeji.com/hj-sdk/AndroidSDK2.6.1.zip')">下载链接</div>
							</div>
						</div>
						<div class="content-item">
							<div class="item-title">iOS</div>
							<div class="item-description">版本号：2.3.1</div>
							<div class="item-btns">
								<div class="btn" @click="goUrl('https://www.showdoc.com.cn/2474466204336934/11043069917845623')">接入文档</div>
								<div class="btn" @click="goUrl('https://cdn.huimiaokeji.com/hj-sdk/iOSSDK2.3.1.zip')">下载链接</div>
							</div>
						</div>
						<div class="content-item">
							<div class="item-title">Flutter</div>
							<div class="item-description">版本号：2.6.2</div>
							<div class="item-btns">
								<div class="btn" @click="goUrl('https://www.showdoc.com.cn/2482440231539737/11023344839274751')">接入文档</div>
								<div class="btn" @click="goUrl('https://cdn.huimiaokeji.com/hj-sdk/flutter-sdk-2.6.2.zip')">下载链接</div>
							</div>
						</div>
					</div>
					</div>
					<div class="content-box-wrap">
					<div class="content-box" style="margin-top: 50px;">
						<div class="content-item">
							<div class="item-title">Unity</div>
							<div class="item-description">版本号：2.0.1</div>
							<div class="item-btns">
								<div class="btn" @click="goUrl('https://www.showdoc.com.cn/2474466204336934/11558378691901827')">接入文档</div>
								<div class="btn" @click="goUrl('https://cdn.huimiaokeji.com/hj-sdk/HuiJingAd.unitypackage.zip')">下载链接</div>
							</div>
						</div>
						<div class="content-item" style="background-color: #F3F7FF;">
							<div class="item-title"></div>
							<div class="item-description"></div>
						</div>
						<div class="content-item" style="background-color: #F3F7FF;">
							<div class="item-title"></div>
							<div class="item-description"></div>
						</div>
					</div>
					</div>
				</div>
			<footer-menu></footer-menu>
	</div>
</template>

<script>
	import FooterMenu from '../components/footer-menu.vue';
	export default {
		name:'sdk',
		components: {
			FooterMenu
		},
		data() {
			return {
			}
		},
		created() {
		  document.title = '灰鲸网络-SDK';
		},
		methods: {
			goUrl(url){
				window.open(url);
			},
		}
	}
</script>

<style lang="less">
	#sdk {
		background-color: #FFFFFF;
		.header {
			  width: 100%;
			  z-index: 999999;
			  position: fixed;
			  left: 0;
			  top:0 ;
			  display: flex;
			   height: 80px;
			   background-color: #FFFFFF;
			  .logo-box {
				  flex:1;
				  display: flex;
				  align-items: center;
				  .logo {
					margin-left: 40px;
					width: 205px;	
					height: 30px;
				  }
			  }
			  .top-menu{
				  flex:1;
					  font-size: 20px;
					  font-family: PingFangSC, PingFang SC;
					  font-weight: 400;
					  color: #333333;
					  line-height: 80px;
					  justify-content: space-between;
					  // padding-left: 200px;
					  // padding-right: 200px;
					  text-align: center;
			  }
			  .login-box {
				  flex:1;
				  cursor: pointer;
				  .login-btn {
					  width: 120px;
					  height: 80px;
					  background: #0B00B5;
					  font-family: PingFangSC, PingFang SC;
					  font-weight: bold;
					  font-size: 14px;
					  color: #FFFFFF;
					  line-height: 80px;
					  text-align: center;
					  font-style: normal;
					  float: right;
				  }
			  }
		  }
		  .platform-section{
		  		  height: 720px;
		  		  background: #F3F7FF;
		  		  .title {
		  			  padding-top:50px;
		  			  font-family: PingFangSC, PingFang SC;
		  			  font-weight: bold;
		  			  font-size: 34px;
		  			  color: #0B00B5;
		  			  line-height: 34px;
		  			  text-align: center;
		  			  font-style: normal;
		  		  }
		  		  .content-box-wrap {
		  			  display: flex;
		  			  justify-content: center;
		  		  .content-box {
		  			  display: flex;
		  			  .content-item {
		  				  width: 373px;
		  				  height: 223px;
		  				  background: #FFFFFF;
		  				  position: relative;
		  				  .item-title {
		  					  padding-top: 40px;
		  					  padding-left: 40px;
		  					  font-family: PingFangSC, PingFang SC;
		  					  font-weight: bold;
		  					  font-size: 24px;
		  					  color: #333333;
		  					  line-height: 24px;
		  					  text-align: left;
		  					  font-style: normal;
		  				  }
		  				  .item-description {
		  					  position:absolute;
		  					  width: 293px;
		  					  left: 40px;
		  					  top: 94px;
		  					  font-family: PingFangSC, PingFang SC;
		  					  font-weight: 400;
		  					  font-size: 16px;
		  					  color: #666666;
		  					  line-height: 20px;
		  					  text-align: justify;
		  					  font-style: normal;
		  				  }
						  .item-btns {
							  margin-top: 50px;
							  display: flex;
							  justify-content: space-between;
							  position:absolute;
							  bottom: 0;
							  left: 20px;
							  width: 333px;
							  height: 60px;
							  .btn {
								  font-size: 16px;
								  color: #0B00B5;
								  line-height: 60px;
								  cursor: pointer;
							  }
						  }
		  				  .icon {
		  					  position:absolute;
		  					  bottom: 0;
		  					  right: 0;
		  					  width: 90px;
		  					  height: 90px;
		  				  }
		  				  .item-text-active {
		  				  				  color: #FFFFFF;
		  				  }
		  				  &:not(:last-child) {  
		  					  margin-right: 41px;
		  				  }
		  			  }
		  			  .item-active {
		  				  background: #0B00B5;
		  			  }
		  			  
		  		  }
		  		  }
		  }
	}
</style>


// WEBPACK FOOTER //
// src/pages/Sdk.vue